import React, { useState } from 'react';
import axios from 'axios';
import { BaseUrl } from "../../config"

function UploadForm() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(`${BaseUrl}/contact/generateContacts`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.log('Respuesta del servidor:', response.data);
      // Aquí podrías añadir lógica adicional para manejar la respuesta del servidor, como mostrar un mensaje de éxito al usuario.
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      // Aquí podrías añadir lógica adicional para manejar errores, como mostrar un mensaje de error al usuario.
    }

    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <input type="file" onChange={handleFileChange} />
      <button type="submit" disabled={!file || loading}>Cargar Archivo</button>
      {/* Aquí podrías añadir un elemento para mostrar un indicador de carga si 'loading' es true */}
    </form>
  );
}

export default UploadForm;
